import { useTranslation } from "react-i18next";

const FooterStyle = () => {
  const { t } = useTranslation();
  return (
    <footer className="iq-footer app-footer">
      © {new Date().getFullYear()} AFO MEDIA · {t("all rights reserved")}
    </footer>
  );
};

export default FooterStyle;
